import { observer } from 'mobx-react-lite';
import {
  Button,
  Text,
  Widget,
  WidgetHeader,
  WidgetProps,
} from '../../../../../components';
import { ProductHelp } from '../../../../../store/constants/help';
import Product from '../../../store/Product';
import EditRule from './components/EditRule';
import ListRules from './components/ListRules';

export default observer(function FileMovementWidget({
  product,
  ...rest
}: {
  product: Product;
} & Omit<WidgetProps, 'title'>) {
  const rules = product.extendedFeatures.fileMovements;

  return (
    <Widget surface="gray" {...rest}>
      <WidgetHeader
        title={
          <>
            Move Files After Extraction{' '}
            {ProductHelp.extendedFeatures.rulesWikiLink}
          </>
        }
      >
        {!rules.selected && (
          <Button
            icon="plus"
            onClick={() => rules.createRule()}
            size="small"
            type="primaryText"
          >
            Create rule
          </Button>
        )}
      </WidgetHeader>

      {!rules.selected && (
        <Text sx={{ mb: 2 }} variant="hint">
          {ProductHelp.extendedFeatures.rulesVersionHint}
        </Text>
      )}

      {!rules.selected && <ListRules rules={rules} />}

      {rules.selected && (
        <EditRule
          onClose={() => rules.selectRule(undefined)}
          product={product}
          rule={rules.selected}
        />
      )}
    </Widget>
  );
});
